import { Panel } from './Panel';
import { Config } from './Config';
import { Single, StateS } from '../../../Panel/ProtoPanes/Single';
export interface S {
    color: string;
    gap: number;
    filtroType: string;
    filtro: number
}
export type State = StateS & S;
export class Programas extends Single<S> {
    constructor(p: any) {
        super(p);
        this.init({ filtro: 0, color: '#f0f0f0', filtroType: 'none', gap: 5 });
    }
    Config = () => <Config
        save={this.save}
        key='config'
        setConfig={this.setData}
        title={this.state.title}
        setTitle={this.setTitle}
        config={this.state} />
    Panel = () => <Panel key='panel' config={this.state} />
    getDataSave = () => {
        const { title, color, gap, filtro, filtroType } = this.state;
        const data = JSON.stringify({});
        const props = JSON.stringify({ color, gap, filtro, filtroType });
        return { title, html: '', data, props, type: 'programas' };
    }

}
